(function(){'use strict';function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var DATA_SCRIPT_ID="influencer-gift-data",INFLUENCER_GIFT_PROPERTY="_influencer_gift";function normalizeCode(e){return e?e.trim().toLowerCase():""}function toHex(e){return Array.from(new Uint8Array(e)).map((function(e){return e.toString(16).padStart(2,"0")})).join("")}function hmacSha256(e,t){return _hmacSha.apply(this,arguments)}function _hmacSha(){return (_hmacSha=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a,i;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(window.crypto&&window.crypto.subtle){e.next=2;break}return e.abrupt("return","");case 2:return n=new TextEncoder,e.next=5,window.crypto.subtle.importKey("raw",n.encode(r),{name:"HMAC",hash:"SHA-256"},!1,["sign"]);case 5:return a=e.sent,e.next=8,window.crypto.subtle.sign("HMAC",a,n.encode(t));case 8:return i=e.sent,e.abrupt("return",toHex(i));case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function parseData(){var e=document.getElementById(DATA_SCRIPT_ID);if(!e)return null;try{return JSON.parse(e.textContent)}catch(e){return null}}function parseMinimumOrderValue(e){if(null==e||""===e)return null;var t="number"==typeof e?e:parseFloat(String(e).replace(",","."));return Number.isNaN(t)||t<=0?null:t}function getNonGiftDiscountedTotal(e){var t=Number(e&&e.total_price)||0,r=(e&&Array.isArray(e.items)?e.items:[]).reduce((function(e,t){return t.properties&&"true"===t.properties[INFLUENCER_GIFT_PROPERTY]?e+(Number(t.final_line_price)||0):e}),0);return Math.max(0,t-r)}function meetsMinimumOrderValue(e,t){var r=parseMinimumOrderValue(e.minimumOrderValue);return null===r||getNonGiftDiscountedTotal(t)>=Math.round(100*r)}function getDiscountCodesFromCart(e){return (e&&Array.isArray(e.discount_codes)?e.discount_codes:[]).map((function(e){return normalizeCode(e&&e.code)})).filter(Boolean)}function isWithinDateRange(e,t){var r=e.startAt?Date.parse(e.startAt):Number.NaN,n=e.endAt?Date.parse(e.endAt):Number.NaN;return !(!Number.isNaN(r)&&t<r)&&!(!Number.isNaN(n)&&t>n)}function fetchCart(){return _fetchCart.apply(this,arguments)}function _fetchCart(){return (_fetchCart=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.prev=0,e.next=3,fetch("/cart.js",{headers:{Accept:"application/json"}});case 3:if((t=e.sent).ok){e.next=6;break}return e.abrupt("return",null);case 6:return e.next=8,t.json();case 8:return e.abrupt("return",e.sent);case 11:return e.prev=11,e.t0=e.catch(0),e.abrupt("return",null);case 14:case"end":return e.stop()}}),e,null,[[0,11]])})))).apply(this,arguments)}function getInfluencerGiftLines(e){return (e&&Array.isArray(e.items)?e.items:[]).filter((function(e){return e.properties&&"true"===e.properties[INFLUENCER_GIFT_PROPERTY]}))}function getCartUiElement(){return document.querySelector("cart-notification")||document.querySelector("cart-drawer")}function markCartAsNotEmpty(){var e=document.querySelector("cart-drawer");e&&e.classList.contains("is-empty")&&e.classList.remove("is-empty");var t=document.querySelector("cart-drawer .drawer__inner");t&&t.classList.contains("is-empty")&&t.classList.remove("is-empty");}function addInfluencerGift(e){return _addInfluencerGift.apply(this,arguments)}function _addInfluencerGift(){return (_addInfluencerGift=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,a,i;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=getCartUiElement(),n={items:[{id:Number(t),quantity:1,properties:_defineProperty({},INFLUENCER_GIFT_PROPERTY,"true")}]},r&&"function"==typeof r.getSectionsToRender&&(n.sections=r.getSectionsToRender().map((function(e){return e.id})),n.sections_url=window.location.pathname),e.next=5,fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify(n)});case 5:if((a=e.sent).ok){e.next=8;break}return e.abrupt("return");case 8:return e.next=10,a.json();case 10:i=e.sent,r&&"function"==typeof r.renderContents&&i.sections&&(r.renderContents(i),markCartAsNotEmpty());case 12:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function updateCartLines(e,t){return _updateCartLines.apply(this,arguments)}function _updateCartLines(){return (_updateCartLines=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a,i,u,o;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=getCartUiElement(),a=!!(r&&n&&n.classList&&n.classList.contains("active")),i={updates:t},a&&"function"==typeof n.getSectionsToRender&&(i.sections=n.getSectionsToRender().map((function(e){return e.id})),i.sections_url=window.location.pathname),e.next=6,fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},body:JSON.stringify(i)});case 6:if((u=e.sent).ok){e.next=9;break}return e.abrupt("return");case 9:return e.next=11,u.json();case 11:o=e.sent,a&&"function"==typeof n.renderContents&&o.sections&&n.renderContents(o);case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}var isReconciling=!1,reconcilePending=!1,unsubscribeCartUpdate=null;function reconcileGift(e){return _reconcileGift.apply(this,arguments)}function _reconcileGift(){return (_reconcileGift=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,a,i,u,o;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!isReconciling){e.next=3;break}return reconcilePending=!0,e.abrupt("return");case 3:return isReconciling=!0,e.prev=4,e.next=7,fetchCart();case 7:if(r=e.sent){e.next=10;break}return e.abrupt("return");case 10:if(n=!!t&&meetsMinimumOrderValue(t,r),a=t&&t.variantId&&n?Number(t.variantId):null,i={},u=!1,getInfluencerGiftLines(r).forEach((function(e){e.key&&(null!==a&&Number(e.variant_id)===a&&!u?(u=!0,1!==e.quantity&&(i[e.key]=1)):i[e.key]=0);})),o=null!==a&&!u,!(Object.keys(i).length>0)){e.next=20;break}return e.next=20,updateCartLines(i,!o);case 20:if(!o){e.next=23;break}return e.next=23,addInfluencerGift(a);case 23:return e.prev=23,isReconciling=!1,reconcilePending&&(reconcilePending=!1,reconcileGift(t)),e.finish(23);case 27:case"end":return e.stop()}}),e,null,[[4,,23,27]])})))).apply(this,arguments)}function resolveActiveEntry(e,t){return _resolveActiveEntry.apply(this,arguments)}function _resolveActiveEntry(){return _resolveActiveEntry=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a,i;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=Date.now(),a=t.filter((function(e){return e&&Array.isArray(e.codeHashes)&&e.codeHashes.length>0&&isWithinDateRange(e,n)})),e.next=4,Promise.all(a.map(function(){var e=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var n,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.hashSalt||window.location.hostname,e.next=3,Promise.all(r.map((function(e){return hmacSha256(e,n)})));case 3:return a=e.sent,e.abrupt("return",a.some((function(e){return e&&t.codeHashes.includes(e)}))?t:null);case 5:case"end":return e.stop()}}),e)})));return function(t){return e.apply(this,arguments)}}()));case 4:return i=e.sent,e.abrupt("return",i.find(Boolean)||null);case 6:case"end":return e.stop()}}),e)}))),_resolveActiveEntry.apply(this,arguments)}function initInfluencerGift(){return _initInfluencerGift.apply(this,arguments)}function _initInfluencerGift(){return (_initInfluencerGift=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t,r,n,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((t=parseData())&&Array.isArray(t.entries)){e.next=3;break}return e.abrupt("return");case 3:return e.next=5,fetchCart();case 5:if(r=e.sent){e.next=8;break}return e.abrupt("return");case 8:if(!((n=getDiscountCodesFromCart(r)).length>0)){e.next=15;break}return e.next=12,resolveActiveEntry(t.entries,n);case 12:e.t0=e.sent,e.next=16;break;case 15:e.t0=null;case 16:return a=e.t0,e.next=19,reconcileGift(a);case 19:a&&"function"==typeof subscribe&&"undefined"!=typeof PUB_SUB_EVENTS&&PUB_SUB_EVENTS.cartUpdate&&("function"==typeof unsubscribeCartUpdate&&unsubscribeCartUpdate(),unsubscribeCartUpdate=subscribe(PUB_SUB_EVENTS.cartUpdate,(function(){return reconcileGift(a)})));case 20:case"end":return e.stop()}}),e)})))).apply(this,arguments)}"loading"===document.readyState?document.addEventListener("DOMContentLoaded",initInfluencerGift):initInfluencerGift(),window.addEventListener("pageshow",(function(e){e.persisted&&initInfluencerGift();}));})();